import * as React from "react";
import { Box, Typography, Avatar, Grid } from "@mui/material";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { setlogo } from "./Nav/navSlice";
import { useGetQEJobCardHistoryQuery } from "../api/apiSlice";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import {
  useDownloadInstallationImagesMutation,
  useDownloadDigitalCOCMutation,
  useAddChangeLogMutation,
  useEditIMSSmartnodeMutation,
} from "../api/apiSlice";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import EditIcon from "@mui/icons-material/Edit";
import { showError, showSuccess } from "../../Global/notifications/notificationsSlice";
import { useNavigate } from "react-router-dom";
import { useEditJobCardMutation } from "../api/apiSlice";
import { useSelector } from "react-redux";
import { getUserName } from "../Authentication/authSlice";
import { useGetPendingJobCardsQuery } from "../api/apiSlice";
import { useParams } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { useState } from "react";
import { BG, CARD_BG, BORDER, LABEL, AMBER } from "../../Global/colors";

const cardSx = {
  backgroundColor: CARD_BG,
  border: `1px solid ${BORDER}`,
  borderRadius: "12px",
  p: "16px 18px",
  mb: "10px",
};

export default function InstallDetailsWrapper() {
  const { pageName, id } = useParams();
  const { data: pendingJobCards, isSuccess: isPendingSuccess } = useGetPendingJobCardsQuery();
  const { data: historyJobCards, isSuccess: isHistorySuccess } = useGetQEJobCardHistoryQuery();

  const job_card_data = pageName === "history" ? historyJobCards : pendingJobCards;
  const isSuccess = pageName === "history" ? isHistorySuccess : isPendingSuccess;

  if (isSuccess && job_card_data) {
    const job_card_data_for_id = job_card_data.job_cards.find(
      (item) => item.id === parseInt(id, 10)
    );
    return <InstallDetails job_card_data={job_card_data_for_id} pageName={pageName} />;
  }
  return <></>;
}

function InstallDetails({ job_card_data, pageName }) {
  const dispatch = useDispatch();
  dispatch(setlogo(false));

  return (
    <>
      <Helmet>
        <style>{`body { background: ${BG}; }`}</style>
      </Helmet>

      <Box sx={{ px: "16px", pt: "80px", pb: "40px", maxWidth: "480px", mx: "auto" }}>
        <InstallType data={job_card_data} />
        <SimImsiCard data={job_card_data} />
        <Address data={job_card_data} />
        <BuildingName data={job_card_data} />
        <UnitNumber data={job_card_data} />
        <ErfNumber data={job_card_data} />
        <ReferenceNumber data={job_card_data} />
        <Checkboxes data={job_card_data} />
        <InstalledBy data={job_card_data} />
        {pageName === "pending-installs" ? (
          <ImagesForApproval data={job_card_data} approve={true} />
        ) : (
          <>
            <ImagesForApproval data={job_card_data} />
            <Box sx={{ display: "flex", gap: "12px", mt: "16px" }}>
              <DownloadImages data={job_card_data} />
              <DownloadCOC data={job_card_data} />
            </Box>
            <EditCOC data={job_card_data} />
          </>
        )}
      </Box>
    </>
  );
}

function InfoCard({ label, value }) {
  return (
    <Box sx={cardSx}>
      <Typography sx={{ color: LABEL, fontSize: "0.72rem", mb: "4px" }}>{label}</Typography>
      <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>{value || "—"}</Typography>
    </Box>
  );
}

function InstallType({ data }) {
  const install_type =
    data.install_state === "UN"
      ? "Uninstall"
      : data.install_state === "RE"
      ? "Replacement"
      : "New installation";
  return <InfoCard label="Install Type" value={install_type} />;
}

function SimImsiCard({ data }) {
  
   const serial_number =
    data.install_state == "UN"
      ? data.archived_serial_number
      : data.install_state == "RE"
      ? data.archived_serial_number
      : data.serial_number;

      const imsi_number =
    data.install_state == "UN"
      ? data.archived_imsi_number
      : data.install_state == "RE"
      ? data.archived_imsi_number
      : data.imsi_number;

  return (
    <Box sx={cardSx}>
      <Box sx={{ display: "flex", gap: "24px" }}>
        <Box>
          <Typography sx={{ color: LABEL, fontSize: "0.72rem", mb: "4px" }}>Serial number</Typography>
          <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>{serial_number || "—"}</Typography>
        </Box>
        <Box>
          <Typography sx={{ color: LABEL, fontSize: "0.72rem", mb: "4px" }}>IMSI number</Typography>
          <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>{imsi_number || "—"}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

function Address({ data }) {
  return <InfoCard label="Address" value={data.address} />;
}

function BuildingName({ data }) {
  if (!data.building_name) return null;
  return <InfoCard label="Building Name" value={data.building_name} />;
}

function UnitNumber({ data }) {
  if (!data.unit_number) return null;
  return <InfoCard label="Unit Number" value={data.unit_number} />;
}

function ErfNumber({ data }) {
  const erf = data.erf_number;
  return (
    <Box sx={cardSx}>
      <Typography sx={{ color: LABEL, fontSize: "0.72rem", mb: "4px" }}>Erf / Stand No</Typography>
      {erf ? (
        <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>{erf}</Typography>
      ) : (
        <Typography sx={{ color: "rgba(255,255,255,0.3)", fontWeight: 400, fontSize: "0.95rem", fontStyle: "italic" }}>Not captured</Typography>
      )}
    </Box>
  );
}

function ReferenceNumber({ data }) {
  return <InfoCard label="Install reference number" value={data.reference_id} />;
}

function BoolRow({ label, value }) {
  return (
    <Box sx={{ mb: "14px" }}>
      <Typography sx={{ color: LABEL, fontSize: "0.72rem", mb: "6px" }}>{label}</Typography>
      {value ? (
        <CheckCircleOutlineIcon sx={{ color: "#4caf50", fontSize: "1.4rem" }} />
      ) : (
        <HighlightOffIcon sx={{ color: "#f44336", fontSize: "1.4rem" }} />
      )}
    </Box>
  );
}

function Checkboxes({ data }) {
  return (
    <Box sx={cardSx}>
      <BoolRow label="Customer Controlled Breaker" value={data.breaker_control} />
      <BoolRow label="Timer installed" value={data.timer_installed} />
      <BoolRow label="Solar Geyser" value={data.solar_geyser} />
      <BoolRow label="Solar PV Installed" value={data.solar_pv} />
    </Box>
  );
}

function InstalledBy({ data }) {
  const initials = data.installer_name
    ? data.installer_name.split(" ").map((n) => n[0]).join("")
    : "?";
  return (
    <Box sx={{ ...cardSx, display: "flex", alignItems: "center", gap: "14px" }}>
      <Avatar sx={{ bgcolor: "rgba(255,255,255,0.12)", color: "#fff", fontWeight: 700, width: 40, height: 40 }}>
        {initials}
      </Avatar>
      <Box>
        <Typography sx={{ color: LABEL, fontSize: "0.72rem", mb: "2px" }}>Installed by:</Typography>
        <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>{data.installer_name}</Typography>
      </Box>
    </Box>
  );
}

function VetButton({ label, active, variant, onClick }) {
  const isApprove = variant === "approve";
  const activeBg = isApprove ? "rgba(34,197,94,0.14)" : "rgba(239,68,68,0.14)";
  const activeColor = isApprove ? "#22C55E" : "#EF4444";
  const activeBorder = isApprove ? "rgba(34,197,94,0.45)" : "rgba(239,68,68,0.5)";
  const Icon = active
    ? isApprove ? CheckCircleIcon : CancelIcon
    : isApprove ? CheckCircleOutlineIcon : HighlightOffIcon;

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      startIcon={<Icon sx={{ fontSize: "1rem !important" }} />}
      sx={{
        flex: 1,
        py: "9px",
        px: "12px",
        borderRadius: "8px",
        fontSize: "0.82rem",
        fontWeight: 600,
        textTransform: "none",
        color: active ? activeColor : "rgba(255,255,255,0.55)",
        borderColor: active ? activeBorder : "rgba(255,255,255,0.08)",
        backgroundColor: active ? activeBg : "transparent",
        "&:hover": {
          color: active ? activeColor : "#fff",
          borderColor: active ? activeBorder : "rgba(255,255,255,0.18)",
          backgroundColor: active ? activeBg : "transparent",
        },
      }}
    >
      {label}
    </Button>
  );
}

function VettablePhotoCard({ label, src, alt, photoIdx, vetState, onVet, pending }) {
  const approved = vetState === "approved";
  const declined = vetState === "declined";

  const borderColor = approved
    ? "rgba(34,197,94,0.45)"
    : declined
    ? "rgba(239,68,68,0.5)"
    : BORDER;

  return (
    <Box sx={{ ...cardSx, mb: "12px", borderColor, transition: "border-color 0.18s ease" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "10px" }}>
        <Typography sx={{ color: "rgba(255,255,255,0.35)", fontSize: "0.7rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", flexShrink: 0 }}>
          Photo {photoIdx}
        </Typography>
        <Typography sx={{ color: LABEL, fontSize: "0.75rem", textAlign: "right", ml: "10px" }}>{label}</Typography>
      </Box>
      {src ? (
        <img src={src} alt={alt} style={{ width: "100%", height: "auto", borderRadius: "8px", display: "block" }} />
      ) : (
        <Box
          sx={{
            width: "100%",
            aspectRatio: "4/3",
            backgroundColor: "#0d1117",
            border: `1px dashed rgba(255,255,255,0.1)`,
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CameraAltOutlinedIcon sx={{ color: AMBER, opacity: 0.5, fontSize: "2rem" }} />
        </Box>
      )}
      {pending && (
        <Box sx={{ display: "flex", gap: "10px", mt: "12px" }}>
          <VetButton
            label="Approve"
            active={approved}
            variant="approve"
            onClick={() => onVet(photoIdx, approved ? null : "approved")}
          />
          <VetButton
            label="Decline"
            active={declined}
            variant="decline"
            onClick={() => onVet(photoIdx, declined ? null : "declined")}
          />
        </Box>
      )}
    </Box>
  );
}

const INSTALL_PHOTOS = [
  { key: "install_photo_before", label: "Work Area Before Install",          alt: "Before Work Area" },
  { key: "before_photo_on",      label: "DB Board Cover On Before Install",  alt: "Before Photo On"  },
  { key: "before_photo_off",     label: "DB Board Cover Off Before Install", alt: "Before Photo Off" },
  { key: "after_photo_on",       label: "DB Board Cover On After Install",   alt: "After Photo On"   },
  { key: "after_photo_off",      label: "DB Board Cover Off After Install",  alt: "After Photo Off"  },
  { key: "install_photo_after",  label: "Work Area After Install",           alt: "After Work Area"  },
];

function ImagesForApproval({ data, approve }) {
  const [vetStates, setVetStates] = useState({ 1: null, 2: null, 3: null, 4: null, 5: null, 6: null });

  function handleVet(photoIdx, state) {
    setVetStates((prev) => ({ ...prev, [photoIdx]: state }));
  }

  const declinedIndices = Object.keys(vetStates).filter((k) => vetStates[k] === "declined").map(Number);
  const pendingCount = Object.values(vetStates).filter((s) => s === null).length;
  const anyDeclined = declinedIndices.length > 0;
  const allApproved = pendingCount === 0 && !anyDeclined;

  return (
    <>
      {approve && (
        <Typography sx={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.45)", textAlign: "center", mb: "12px", lineHeight: 1.5 }}>
          Tick each photo to approve, or cross to decline. If any photo is declined, the install must be declined.
        </Typography>
      )}
      {INSTALL_PHOTOS.map((p, i) => (
        <VettablePhotoCard
          key={p.key}
          photoIdx={i + 1}
          label={p.label}
          src={data[p.key]}
          alt={p.alt}
          vetState={approve ? vetStates[i + 1] : null}
          onVet={handleVet}
          pending={!!approve}
        />
      ))}
      {approve && (
        <ApproveDeclineButtons
          data={data}
          allApproved={allApproved}
          anyDeclined={anyDeclined}
          declinedIndices={declinedIndices}
          pendingCount={pendingCount}
          vetStates={vetStates}
        />
      )}
    </>
  );
}

function ApproveDeclineButtons({ data, allApproved, anyDeclined, declinedIndices, pendingCount, vetStates }) {
  const [openDeclineDialog, setOpenDeclineDialog] = useState(false);
  const [openApproveDialog, setOpenApproveDialog] = useState(false);

  let statusText;
  if (anyDeclined) {
    const labels = declinedIndices.map((n) => `Photo ${n}`);
    const joined =
      labels.length === 1
        ? labels[0]
        : labels.slice(0, -1).join(", ") + " and " + labels[labels.length - 1];
    statusText = `${joined} declined — install must be declined.`;
  } else if (pendingCount > 0) {
    statusText = `${pendingCount} of 6 photos still need vetting.`;
  } else {
    statusText = "All photos approved — ready to approve install.";
  }

  return (
    <>
      <Box sx={{ display: "flex", gap: "12px", justifyContent: "center", mt: "24px", mb: "8px" }}>
        <Button
          variant="outlined"
          startIcon={<CancelIcon />}
          disabled={!anyDeclined}
          onClick={() => setOpenDeclineDialog(true)}
          sx={{
            color: "#fff",
            borderColor: "rgba(255,255,255,0.2)",
            borderRadius: "10px",
            px: "24px",
            py: "10px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { borderColor: "rgba(255,255,255,0.4)", backgroundColor: "rgba(255,255,255,0.05)" },
            "&.Mui-disabled": { color: "rgba(255,255,255,0.25)", borderColor: "rgba(255,255,255,0.08)" },
          }}
        >
          Decline
        </Button>
        <Button
          variant="contained"
          startIcon={<CheckCircleIcon />}
          disabled={!allApproved}
          onClick={() => setOpenApproveDialog(true)}
          sx={{
            backgroundColor: AMBER,
            color: "#0d1117",
            borderRadius: "10px",
            px: "24px",
            py: "10px",
            textTransform: "none",
            fontWeight: 700,
            boxShadow: "none",
            "&:hover": { backgroundColor: "#e5a730", boxShadow: "none" },
            "&.Mui-disabled": { backgroundColor: "rgba(253,185,64,0.25)", color: "rgba(13,17,23,0.5)" },
          }}
        >
          Approve
        </Button>
      </Box>
      <Typography sx={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.45)", textAlign: "center", mb: "16px", lineHeight: 1.5 }}>
        {statusText}
      </Typography>

      <DeclineDialog
        openDeclineDialog={openDeclineDialog}
        setOpenDeclineDialog={setOpenDeclineDialog}
        data={data}
        declinedIndices={declinedIndices}
        vetStates={vetStates}
      />
      <ApproveDialogs
        openApproveDialog={openApproveDialog}
        setOpenApproveDialog={setOpenApproveDialog}
        data={data}
        vetStates={vetStates}
      />
    </>
  );
}

const dialogPaperSx = {
  "& .MuiDialog-paper": {
    backgroundColor: "#161B22",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "#fff",
  },
  "& .MuiDialogTitle-root": { color: "#fff" },
  "& .MuiDialogContentText-root": { color: "rgba(255,255,255,0.6)" },
  "& .MuiInputBase-root": { color: "#fff" },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.45)" },
  "& .MuiInput-underline:before": { borderBottomColor: "rgba(255,255,255,0.2)" },
  "& .MuiInput-underline:hover:before": { borderBottomColor: "rgba(255,255,255,0.4)" },
  "& .MuiSelect-icon": { color: "rgba(255,255,255,0.45)" },
  "& .MuiMenuItem-root": { color: "#fff" },
  "& .MuiMenu-paper": { backgroundColor: "#161B22", border: "1px solid rgba(255,255,255,0.1)" },
};

function DeclineDialog({ openDeclineDialog, setOpenDeclineDialog, data, declinedIndices, vetStates }) {
  const [declineReason, setDeclineReason] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_name = useSelector(getUserName);

  const [editJobCard, { isSuccess: isEditJobCardSuccess, isError: isEditJobCardError, error: editJobCardError }] =
    useEditJobCardMutation();
  const [addChangeLog, { isSuccess: addChangeLogSuccess }] = useAddChangeLogMutation();
  const [editIMSSmartnode] = useEditIMSSmartnodeMutation();

  const statusChoices =
    data.install_state === "NEW"
      ? [
          { value: "QRC",   label: "QR Code Scan",               photoIdxs: [] },
          { value: "BEFWA", label: "Before Work Area Picture",    photoIdxs: [1] },
          { value: "BEF",   label: "Before Photos of DB",         photoIdxs: [2, 3] },
          { value: "AMP",   label: "AMP Test",                    photoIdxs: [] },
          { value: "TES",   label: "Testing",                     photoIdxs: [] },
          { value: "AFT",   label: "After Photos of DB",          photoIdxs: [4, 5] },
          { value: "AFTWA", label: "After Work Area Picture",     photoIdxs: [6] },
        ]
      : data.install_state === "UN"
      ? [
          { value: "BEFWA", label: "Before Work Area Picture",    photoIdxs: [1] },
          { value: "BEF",   label: "Before Photos of DB",         photoIdxs: [2, 3] },
          { value: "UNI",   label: "Uninstall Notes",             photoIdxs: [] },
          { value: "AFT",   label: "After Photos of DB",          photoIdxs: [4, 5] },
          { value: "AFTWA", label: "After Work Area Picture",     photoIdxs: [6] },
        ]
      : [
          { value: "DET",   label: "Geyser Details",              photoIdxs: [] },
          { value: "AMP",   label: "AMP Test",                    photoIdxs: [] },
          { value: "TES",   label: "Testing",                     photoIdxs: [] },
          { value: "AFT",   label: "After Photos of DB",          photoIdxs: [4, 5] },
          { value: "AFTWA", label: "After Work Area Picture",     photoIdxs: [6] },
        ];

  // Pre-seed checked steps from declined photo indices whenever the dialog opens.
  const computeInitialChecked = () => {
    const seeded = {};
    statusChoices.forEach((s) => {
      seeded[s.value] = s.photoIdxs.some((idx) => declinedIndices.includes(idx));
    });
    return seeded;
  };
  const [checkedSteps, setCheckedSteps] = useState(computeInitialChecked);

  // Re-seed when declined indices change (dialog re-opened with different state).
  React.useEffect(() => {
    setCheckedSteps(computeInitialChecked());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [declinedIndices.join(",")]);

  function toggleStep(value) {
    setCheckedSteps((prev) => ({ ...prev, [value]: !prev[value] }));
  }

  const selectedSteps = statusChoices.filter((s) => checkedSteps[s.value]).map((s) => s.value);

  const handleDecline = () => {
    const serial_number = data.install_state === "UN" ? data.archived_serial_number : data.serial_number;
    addChangeLog({ body: { serial_number, change: "QE declined the job, installer will be notified to REDO" } });
  };

  React.useEffect(() => {
    if (addChangeLogSuccess) {
      const serial_number = data.install_state === "UN" ? data.archived_serial_number : data.serial_number;
      const imsi_number = data.install_state === "UN" ? data.archived_imsi_number : data.imsi_number;
      editIMSSmartnode({
        body: {
          serial_number,
          imsi_number,
          status: "Declined",
          change: "QE declined the job, installer will be notified to REDO",
        },
      });
      editJobCard({
        body: {
          serial_number: data.serial_number,
          imsi_number: data.imsi_number,
          reference_id: data.reference_id,
          qe_job_state: "Declined",
          qe_name: user_name,
          qe_decline_reason: declineReason,
          qe_decline_resume_from: selectedSteps[0] || "",
          photo_vet_states: vetStates,
          state: "REDO",
        },
      });
      setOpenDeclineDialog(false);
    }
  }, [addChangeLogSuccess]);

  React.useEffect(() => {
    if (isEditJobCardSuccess) {
      navigate(-1);
      dispatch(showSuccess("Action completed successfully"));
    }
  }, [isEditJobCardSuccess, navigate, dispatch]);

  React.useEffect(() => {
    if (isEditJobCardError) {
      dispatch(showError(editJobCardError?.data?.error || "An error occurred"));
    }
  }, [isEditJobCardError, editJobCardError, dispatch]);

  // Auto-lead: "Declined because of pictures X and Y."
  const autoLead = declinedIndices.length > 0
    ? (() => {
        const labels = declinedIndices.map((n) => `picture ${n}`);
        const joined =
          labels.length === 1
            ? labels[0]
            : labels.slice(0, -1).join(", ") + " and " + labels[labels.length - 1];
        return `Declined because of ${joined}.`;
      })()
    : null;

  const outlinedFieldSx = {
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "rgba(255,255,255,0.15)" },
      "&:hover fieldset": { borderColor: "rgba(255,255,255,0.3)" },
      "&.Mui-focused fieldset": { borderColor: AMBER },
      backgroundColor: "rgba(255,255,255,0.03)",
    },
  };

  return (
    <Dialog open={openDeclineDialog} onClose={() => setOpenDeclineDialog(false)} sx={dialogPaperSx}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Install Declined
        <IconButton size="small" onClick={() => setOpenDeclineDialog(false)} sx={{ color: "rgba(255,255,255,0.4)" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {autoLead && (
          <Box sx={{ p: "9px 12px", mb: "14px", mt: "4px", borderRadius: "6px", backgroundColor: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.25)" }}>
            <Typography sx={{ fontSize: "0.86rem", color: "rgba(255,255,255,0.85)", lineHeight: 1.45 }}>
              {autoLead}
            </Typography>
          </Box>
        )}
        <Typography sx={{ color: LABEL, fontSize: "0.78rem", mb: "6px", mt: "4px" }}>Additional notes (optional)</Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          value={declineReason}
          variant="outlined"
          placeholder="e.g. Photo 'After DB Cover On' is blurred — please retake."
          onChange={(e) => setDeclineReason(e.target.value)}
          sx={{
            mb: "16px",
            ...outlinedFieldSx,
            "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.3)", opacity: 1 },
          }}
        />
        <Typography sx={{ color: LABEL, fontSize: "0.78rem", mb: "6px" }}>Steps the installer must redo:</Typography>
        <Box sx={{ p: "8px 10px", backgroundColor: "#0D1117", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px", maxHeight: "220px", overflowY: "auto" }}>
          <FormGroup>
            {statusChoices.map((option) => {
              const hitDeclined = option.photoIdxs.some((idx) => declinedIndices.includes(idx));
              return (
                <FormControlLabel
                  key={option.value}
                  control={
                    <Checkbox
                      checked={!!checkedSteps[option.value]}
                      onChange={() => toggleStep(option.value)}
                      size="small"
                      sx={{ color: "rgba(255,255,255,0.35)", "&.Mui-checked": { color: AMBER }, py: "3px" }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "0.85rem", color: hitDeclined ? "#FCA5A5" : "rgba(255,255,255,0.78)", fontWeight: hitDeclined ? 500 : 400 }}>
                      {option.label}
                      {option.photoIdxs.length > 0 && (
                        <Box component="span" sx={{ color: "rgba(255,255,255,0.35)", ml: "6px", fontSize: "0.78rem" }}>
                          · photo{option.photoIdxs.length > 1 ? "s" : ""} {option.photoIdxs.join(", ")}
                        </Box>
                      )}
                    </Typography>
                  }
                  sx={{ mx: 0 }}
                />
              );
            })}
          </FormGroup>
        </Box>
        <Typography sx={{ fontSize: "0.74rem", color: "rgba(255,255,255,0.45)", mt: "6px" }}>
          Steps tied to declined photos are pre-checked. Approved steps stay intact on the installer's job card.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDeclineDialog(false)} sx={{ color: "rgba(255,255,255,0.6)" }}>
          Back
        </Button>
        <Button
          onClick={handleDecline}
          variant="contained"
          sx={{ backgroundColor: AMBER, color: "#0d1117", fontWeight: 700, "&:hover": { backgroundColor: "#e5a730" } }}
        >
          Send to Installer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function ApproveDialogs({ openApproveDialog, setOpenApproveDialog, data, vetStates }) {
  const navigate = useNavigate();
  const { pageName } = useParams();

  const handleApprove = () => {
    const navState = { vetStates };
    if (data.install_state === "UN") {
      navigate(`/QE/${pageName}/install/details/${data.id}/approve/${data.reference_id}/${data.archived_serial_number}/${data.archived_imsi_number}/${data.install_state}/`, { state: navState });
    } else {
      navigate(`/QE/${pageName}/install/details/${data.id}/approve/${data.reference_id}/${data.serial_number}/${data.imsi_number}/${data.install_state}/`, { state: navState });
    }
  };

  return (
    <Dialog open={openApproveDialog} onClose={() => setOpenApproveDialog(false)} sx={dialogPaperSx}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Approve and capture digital C.O.C.
        <IconButton size="small" onClick={() => setOpenApproveDialog(false)} sx={{ color: "rgba(255,255,255,0.4)" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "rgba(255,255,255,0.6)" }}>Please confirm</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenApproveDialog(false)} sx={{ color: "rgba(255,255,255,0.6)" }}>
          Back
        </Button>
        <Button
          onClick={handleApprove}
          variant="contained"
          sx={{ backgroundColor: AMBER, color: "#0d1117", fontWeight: 700, "&:hover": { backgroundColor: "#e5a730" } }}
        >
          Capture COC
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function DownloadImages({ data }) {
  const [downloadImages] = useDownloadInstallationImagesMutation();

  const handleDownload = () => {
    downloadImages({ job_card_id: data?.id })
      .unwrap()
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `job_card_${data?.id}_images.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => alert("Failed to download file. Please try again."));
  };

  const downloadBtnSx = {
    flex: 1,
    color: "#fff",
    borderColor: "rgba(255,255,255,0.15)",
    borderRadius: "10px",
    py: "10px",
    fontWeight: 600,
    "&:hover": { borderColor: "rgba(255,255,255,0.3)", backgroundColor: "rgba(255,255,255,0.05)" },
  };

  return (
    <Button
      variant="outlined"
      startIcon={<ArrowDownwardIcon sx={{ color: AMBER }} />}
      onClick={handleDownload}
      sx={downloadBtnSx}
    >
      Download Installation Images
    </Button>
  );
}

function EditCOC({ data }) {
  const navigate = useNavigate();
  const { pageName } = useParams();

  const handleEdit = () => {
    const serial = data.install_state === "UN" ? data.archived_serial_number : data.serial_number;
    const imsi = data.install_state === "UN" ? data.archived_imsi_number : data.imsi_number;
    navigate(
      `/QE/${pageName}/install/details/${data.id}/approve/${data.reference_id}/${serial}/${imsi}/${data.install_state}/`,
      {
        state: {
          existingFront: data.digital_coc_image ?? null,
          existingBack: data.digital_coc_image2 ?? null,
          existingSubDb: data.digital_coc_image3 ?? null,
          existingPdf: data.digital_coc_pdf ?? null,
        },
      }
    );
  };

  return (
    <Button
      variant="outlined"
      startIcon={<EditIcon sx={{ color: AMBER }} />}
      onClick={handleEdit}
      sx={{
        width: "100%",
        mt: "8px",
        color: "#fff",
        borderColor: "rgba(255,255,255,0.15)",
        borderRadius: "10px",
        py: "10px",
        fontWeight: 600,
        "&:hover": { borderColor: "rgba(255,255,255,0.3)", backgroundColor: "rgba(255,255,255,0.05)" },
      }}
    >
      Edit COC
    </Button>
  );
}

function DownloadCOC({ data }) {
  const [downloadImages] = useDownloadDigitalCOCMutation();

  const handleDownload = () => {
    downloadImages({ job_card_id: data.id })
      .unwrap()
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `job_card_${data?.id}_digital_coc.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => alert("Failed to download file. Please try again."));
  };

  const downloadBtnSx = {
    flex: 1,
    color: "#fff",
    borderColor: "rgba(255,255,255,0.15)",
    borderRadius: "10px",
    py: "10px",
    fontWeight: 600,
    "&:hover": { borderColor: "rgba(255,255,255,0.3)", backgroundColor: "rgba(255,255,255,0.05)" },
  };

  return (
    <Button
      variant="outlined"
      startIcon={<ArrowDownwardIcon sx={{ color: AMBER }} />}
      onClick={handleDownload}
      sx={downloadBtnSx}
    >
      Download COC
    </Button>
  );
}
